import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "../data/site";

const LINKS = [
  { label: "Services", id: "services" },
  { label: "Portfolio", id: "portfolio" },
  { label: "Process", id: "process" },
  { label: "Industries", id: "industries" },
  { label: "Contact", id: "contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-ink-900/85 backdrop-blur-xl border-b border-line" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <Logo onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} />

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="font-head text-sm uppercase tracking-wider text-white/70 hover:text-orange transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            data-testid="nav-call"
            className="flex items-center gap-2 text-sm font-head uppercase tracking-wider text-white/80 hover:text-orange transition-colors"
          >
            <Phone size={16} /> {CONTACT.phone}
          </a>
          <button
            data-testid="nav-quote-btn"
            onClick={() => go("quote")}
            className="bg-orange hover:bg-orange-hover text-white font-head font-bold uppercase tracking-wide text-sm px-6 py-3 transition-colors"
          >
            Get a Quote
          </button>
        </div>

        <button
          data-testid="mobile-menu-btn"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-ink-900/98 backdrop-blur-xl border-t border-line px-5 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left font-head uppercase tracking-wider text-white/80 py-1"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-quote-btn"
            onClick={() => go("quote")}
            className="bg-orange text-white font-head font-bold uppercase tracking-wide px-6 py-3 mt-2"
          >
            Get a Free Quote
          </button>
        </div>
      )}
    </header>
  );
};
